import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Loader2, Send, Sparkles, X, Plus } from "lucide-react";
import { useAsistenteChat } from "../lib/useAsistenteChat";

const SUGERENCIAS = [
  "¿Cómo veo cuánto stock tengo de pastillas para la garganta?",
  "¿Qué laboratorios acumulan más stock D parado?",
  "¿Cómo envío los informes PDF a mi equipo?",
  "¿Ha bajado mi stock con más de 1 año?",
];

const fmt = (t) => t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");

export function AyudaIA() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const { msgs, busy, send, reset } = useAsistenteChat();
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" }); }, [msgs]);

  if (pathname.startsWith("/asistente")) return null;
  const ask = (q) => { const m = (q ?? text).trim(); if (!m) return; setText(""); send(m); };

  if (!open) return (
    <button onClick={() => setOpen(true)} data-testid="ayuda-ia-launcher"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-slate-900 text-white shadow-2xl hover:bg-slate-800 hover:scale-105 transition-transform">
      <span className="h-7 w-7 rounded-full bg-emerald-400/20 flex items-center justify-center"><Sparkles size={15} className="text-emerald-400" /></span>
      <span className="text-left leading-tight">
        <span className="block text-[10px] uppercase tracking-widest text-emerald-400 font-bold">Ayuda IA</span>
        <span className="block text-sm font-semibold">¿Tienes dudas? Pregunta</span>
      </span>
    </button>
  );

  return (
    <div className="fixed bottom-6 right-6 z-50 w-[calc(100vw-3rem)] sm:w-[420px] h-[70vh] max-h-[620px] bg-white border border-slate-200 rounded-2xl shadow-2xl flex flex-col overflow-hidden fade-in" data-testid="ayuda-ia-panel">
      <div className="flex items-center justify-between px-4 py-3 bg-slate-900 text-white">
        <div className="flex items-center gap-2">
          <Sparkles size={16} className="text-emerald-400" />
          <div><div className="text-[10px] uppercase tracking-widest text-emerald-400 font-bold">Agente de ayuda</div>
            <div className="text-sm font-bold">Pregunta sobre tus datos o la app</div></div>
        </div>
        <div className="flex gap-1">
          <button onClick={reset} disabled={busy} title="Nueva conversación" className="p-1.5 rounded hover:bg-white/10" data-testid="ayuda-ia-new"><Plus size={16} /></button>
          <button onClick={() => setOpen(false)} className="p-1.5 rounded hover:bg-white/10" data-testid="ayuda-ia-close"><X size={16} /></button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-3 space-y-2 bg-slate-50" data-testid="ayuda-ia-messages">
        {!msgs.length && (
          <div className="space-y-2">
            <p className="text-sm text-slate-600">Hola. Respondo con los datos de tu farmacia (ventas, stock, empleados) y te explico cómo usar cada pantalla.</p>
            {SUGERENCIAS.map((s, i) => (
              <button key={s} onClick={() => ask(s)} data-testid={`ayuda-ia-sugerencia-${i}`}
                className="block w-full text-left text-xs px-3 py-2 bg-white border border-slate-200 rounded-lg hover:border-slate-400 transition-colors">{s}</button>
            ))}
          </div>
        )}
        {msgs.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`} data-testid={`ayuda-ia-msg-${m.role}`}>
            <div className={`max-w-[88%] rounded-2xl px-3 py-2 text-sm whitespace-pre-wrap leading-relaxed ${m.role === "user" ? "bg-slate-900 text-white rounded-br-sm" : "bg-white border border-slate-200 rounded-bl-sm"}`}>
              {m.content ? <span dangerouslySetInnerHTML={{ __html: fmt(m.content) }} /> : <Loader2 size={14} className="animate-spin text-slate-400" />}
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <form onSubmit={(e) => { e.preventDefault(); ask(); }} className="border-t border-slate-200 p-2 flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Escribe tu pregunta…" className="input flex-1" data-testid="ayuda-ia-input" />
        <button type="submit" disabled={busy || !text.trim()} className="btn btn-primary" data-testid="ayuda-ia-send">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
        </button>
      </form>
    </div>
  );
}
